import React from "react";
import type { GetStaticPropsContext, NextPage } from "next";

import LegalDocument from "@components/legal-document";
/* @ts-ignore */
import TermConditions from "public/documents/TerminosYCondiciones.docx";
/* @ts-ignore */
import TermConditionsEng from "public/documents/TerminosYCondicionesEn-US.docx";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { useRouter } from "next/router";

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      locale,
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const TerminosCondiciones: NextPage = (props: any) => {
  const document = props.locale === "es" ? TermConditions : TermConditionsEng;
  const router = useRouter();
  const metaData: IHeadMetaComponent = {
    description: "termAndConditions",
    title: "termsConditions",
    url: router.asPath,
  };

  return (
    <>
      <HeadMeta {...metaData} />
      <LegalDocument document={document} />
    </>
  );
};

export default TerminosCondiciones;
